import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export const headers: Record<string, EnhancedTableHeader> = {
  reference: {
    name: 'reference',
    title: 'Reference',
    type: EnhancedTableHeaderType.Text,
  },
  totalPremium: {
    name: 'totalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  amountDue: {
    name: 'amountDue',
    title: 'Total Amount Due',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  amountReceived: {
    name: 'amountReceived',
    title: 'Total Amount Received',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  commission: {
    name: 'commission',
    title: 'Total Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
    tooltipSettings: {
      headers: {
        BusinessPartner: {
          name: 'BusinessPartner',
          title: 'Business Partner',
          type: EnhancedTableHeaderType.Text,
          tooltipSettings: null,
        },
        Share: {
          name: 'Share',
          title: 'Share',
          type: EnhancedTableHeaderType.RoundedPercentage,
          tooltipSettings: null,
        },
        Commission: {
          name: 'Commission',
          title: 'Commission',
          type: EnhancedTableHeaderType.RoundedCurrency,
          tooltipSettings: null,
        },
      },
    },
  },
  taxOnCommission: {
    name: 'taxOnCommission',
    title: 'Total Tax on Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  amountPaid: {
    name: 'amountPaid',
    title: 'Total Amount Paid',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  linkedAmendment: {
    name: 'linkedAmendment',
    title: 'Linked Amendment',
    type: EnhancedTableHeaderType.Link,
    openUrlInNewTab: false,
    urlTemplate: '/production/amendment/{linkedAmendmentId}',
  },
  viewBreakdown: {
    name: 'viewBreakdown',
    title: '',
    type: EnhancedTableHeaderType.Clickable,
    callback: () => undefined,
  },
};
